import { render, staticRenderFns } from "./ColumnConfigCheckboxInput.vue?vue&type=template&id=42d78223"
import script from "./ColumnConfigCheckboxInput.vue?vue&type=script&lang=ts"
export * from "./ColumnConfigCheckboxInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports